<template>
  <div>
    <div class="quick-design-page">
      <div class="design-body">
        <div class="step-box" v-if="curr_mode === 'default'">
          <div class="step-title">
            <div class="step-num">2</div>
            <div class="step-name">选择款式参数</div>
          </div>
          <div class="step-desc">
            选择服装款式分类、颜色、尺码，设置数量，支持添加多个款式组合成一个订单
          </div>
        </div>
        <div class="step-box" v-else-if="curr_mode === 'custom'">
          <div class="step-title">
            <div class="step-num">3</div>
            <div class="step-name">提交订单</div>
          </div>
          <div class="step-desc">支持一个订单包含多个款式,批量定制更高效</div>
        </div>
        <template v-if="curr_mode === 'default'">
          <div class="design-color-size-quantity">
            <div class="top-title">款式信息</div>
            <div class="style-box">
              <div class="label-box">
                <div class="type-label">款式分类</div>
                <div class="number-label">自定义款号</div>
                <div class="color-label">颜色</div>
                <div class="size-label">尺码</div>
                <div class="quantity-label">数量</div>
                <div class="price-label">基础制作单价(元)</div>
                <div class="operation-label">操作</div>
              </div>
              <div
                class="form-item"
                v-for="(item, index) in style_list"
                :key="index"
              >
                <div class="type-box">
                  <div class="type-item">
                    <Select
                      size="large"
                      v-model="item.parent_product_category_id"
                      @on-change="(value)=>
                        onChangeParentCategory(
                          value,
                          item.parent_product_cate_list,
                          index
                        )
                      "
                    >
                      <Option value="">请选择款式分类</Option>
                      <Option
                        v-for="(v, k) in item.parent_product_cate_list"
                        :key="`dpc1` + k"
                        :value="v.product_category_id"
                      >
                        {{ v.category_name_cn }}
                      </Option>
                    </Select>
                  </div>
                  <div
                    class="type-item"
                    v-show="item.sub_product_category_list.length > 0"
                  >
                    <Select size="large"
                      v-model="item.child_product_category_id"
                      @on-change="(value)=>
                        onChangeSubCategory(
                          value,
                          item.sub_product_category_list,
                          index
                        )
                      "
                    >
                      <Option value="">请选择款式分类</Option>
                      <Option
                        v-for="(v, k) in item.sub_product_category_list"
                        :key="`dpc2` + k"
                        :value="v.product_category_id"
                      >
                        {{ v.category_name_cn }}
                      </Option>
                    </Select>
                  </div>
                </div>
                <div class="number-box">
                  <input
                    placeholder="输入自定义款号..."
                    v-model="item.style_number"
                  />
                </div>
                <div class="color-box">
                  <input placeholder="请输入款式颜色..." v-model="item.color" />
                </div>
                <div class="size-box">
                  <!-- <Select size="large" v-model="item.size" @on-change="onChangeSize">
                    <Option value="">请选择</Option>
                    <Option
                      v-for="(item, index) in item.size_list"
                      :key="index"
                      :value="item"
                    >
                      {{ item }}
                    </Option>
                  </Select> -->
                  <Cascader :data="item.size_list" v-model="item.size_cascader" :render-format="(value)=>{return value[value.length-1]}" @on-change="(value)=>onSizeSelect(value,index)" size="large"></Cascader>
                </div>
                <div class="quantity-box">
                  <input
                    type="number"
                    :min="1"
                    placeholder="输入数量"
                    v-model="item.quantity"
                  />
                </div>
                <div class="price-box">
                  {{ (parseFloat(item.factory_price * item.quantity + item.warehouse_fee * 1 + item.kefu_fee * 1) || 0) | price_format }}
                </div>
                <img
                  @click="onDeleteStyle(index)"
                  src="../../assets/images/icon-del.png"
                  alt=""
                  class="del-ico"
                />
              </div>
            </div>
            <div class="add-more-btn">
              <div class="more-btn" @click="onAddmoreStyle">
                <img
                  src="../../assets/images/icon-add-circle-red.png"
                  alt=""
                  class="add-ico"
                />
                <div class="btn-text">添加款式</div>
              </div>
            </div>
          </div>
          <div class="design-color-size-quantity">
            <div class="note-info-title">订单备注</div>
            <div class="note-info-box">
              <div class="note-box">
                <textarea
                  v-model="remark"
                  placeholder="请输入您的特殊要求或其他需要说明的事项"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="pick-address-box">
            <div class="pick-title">收货地址</div>

            <div class="address-list">
              <div
                :class="['item-box', { active: address_id == item.id }]"
                v-for="(item, index) in address_list"
                :key="index"
              >
                <div class="selected-icon" v-if="address_id === item.id">✔</div>
                <div class="address-item" @click.stop="address_id = item.id">
                  <div class="name">
                    {{ `${item.contact_person} ${item.contact_mobile}` }}
                    <span v-if="item.is_default">默认</span>
                  </div>
                  <div class="address">
                    {{
                      `${item.province}${item.city}${item.zone}${item.address}`
                    }}
                  </div>
                  <!-- <div class="phone">Phone number:{{ item.phone }}</div> -->
                  <div class="btn-box">
                    <div class="btn-item" @click.stop="del(item.id)">删除</div>
                    <div class="line"></div>
                    <div class="btn-item" @click.stop="edit_address(item)">
                      编辑
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-btn" @click="is_popup_show = true">
              <img src="../../assets/images/icon-add-address-quick.png" /><span
                >添加新地址</span
              >
            </div>
          </div>
          <div class="design-img-list">
            <div class="list-title">设计稿</div>
            <div class="img-list">
              <div
                class="img-item"
                v-for="(item, index) in design.image_list"
                :key="index"
              >
                <template v-if="util.test_image(item.raw)">
                  <img :src="item.raw" alt="" style="object-fit: cover" />
                </template>
                <template v-else>
                  <a :href="item.raw" target="_blank">
                    <img
                      :src="util.get_image_icon(item.raw)"
                      alt=""
                      style="object-fit: cover"
                    />
                  </a>
                </template>
                <img
                  @click="deleteImage(index)"
                  src="../../assets/images/icon-close-circle-black.png"
                  alt=""
                  class="remove-icon"
                />
              </div>
              <!-- <div class="img-item"> -->
              <Upload
                type="drag"
                :action="upload_url"
                :data="{ dir: 'template' }"
                multiple
                :before-upload="onBeforeUpload"
                :show-upload-list="false"
              >
                <div class="upload-icon">
                  <img src="../../assets/images/icon-add-match-upload.png" />
                </div>
              </Upload>
              <!-- </div> -->
            </div>
          </div>
        </template>
        <template v-else-if="curr_mode === 'custom'">
          <div class="custom-order-details">
            <div class="detail-title">订单信息</div>
            <table>
              <thead>
                <tr>
                  <th>款式分类</th>
                  <th>自定义款号</th>
                  <th>颜色</th>
                  <th>尺码</th>
                  <th>数量</th>
                  <th>单价(元)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in style_list" :key="index">
                  <td>
                    {{
                      `${item.parent_cate_name} ${
                        item.child_cate_name ? "-" + item.child_cate_name : ""
                      }`
                    }}
                  </td>
                  <td>{{ item.style_number }}</td>
                  <td>{{ item.color }}</td>
                  <td>{{ item.size }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ (parseFloat((item.factory_price * item.quantity + item.warehouse_fee * 1 + item.kefu_fee * 1))) | price_format}}</td>
                </tr>
              </tbody>
            </table>
            <div class="detail-title">设计稿</div>
            <div class="img-list">
              <div
                class="img-item"
                v-for="(item, index) in design.image_list"
                :key="index"
              >
                <template v-if="util.test_image(item.raw)">
                  <img :src="item.raw" alt="" style="object-fit: cover" />
                </template>
                <template v-else>
                  <a :href="item.raw" target="_blank">
                    <img
                      :src="util.get_image_icon(item.raw)"
                      alt=""
                      style="object-fit: cover"
                    />
                  </a>
                </template>
              </div>
            </div>
            <div class="detail-title">订单备注</div>
            <div class="note-info">
              <div class="info-container">
                {{ remark }}
              </div>
            </div>
            <div class="detail-title">收货地址</div>
            <div class="shipping-info">
              <div class="info-container">
                <div class="info-box">
                  <div class="name">
                    {{
                      `${select_address.contact_person} ${select_address.contact_mobile}`
                    }}
                    <span v-if="select_address.is_default">默认</span>
                  </div>
                  <div class="other">
                    {{
                      `${select_address.province}${select_address.city}${select_address.zone}${select_address.address}`
                    }}
                  </div>
                </div>
                <div class="change-btn" @click="curr_mode = 'add-select'">
                  修改地址
                </div>
              </div>
            </div>
          </div>
          <div class="custom-order-details">
            <div class="detail-title title-line">订单明细</div>
            <div class="details-list">
              <div class="list-wrap">
                <div class="list-label">商品总数</div>
                <div class="list-value">x {{ count }}</div>
              </div>
              <div class="list-wrap">
                <div class="list-label">定制品类基础总价</div>
                <div class="list-value">¥{{ total_price | price_format }}</div>
              </div>
              <div class="list-wrap">
                <div class="list-label">运费</div>
                <div class="list-value">¥0.00</div>
              </div>
            </div>
            <div class="final-price">
              <div class="price-wrap">
                <div class="price-label">实付款</div>
                <div class="price-value">¥{{ total_price | price_format }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="curr_mode === 'add-select'">
          <div class="select-address">
            <div class="select-add-title">选择收货地址</div>
            <div class="address-list">
              <div
                class="item-box"
                v-for="(item, index) in address_list"
                :key="index"
              >
                <div style="display: flex; align-items: center">
                  <input
                    type="radio"
                    :name="'address-radio-group'"
                    :checked="address_id == item.id"
                    @click.stop="address_id = item.id"
                  />
                  <div class="address-item" @click.stop="address_id = item.id">
                    <div class="name">
                      {{ `${item.contact_person} ${item.contact_mobile}` }}
                      <span v-if="item.is_default">默认</span>
                    </div>
                    <div class="address">
                      {{
                        `${item.province}${item.city}${item.zone}${item.address}`
                      }}
                    </div>
                    <!-- <div class="phone">Phone number:{{ item.phone }}</div> -->
                  </div>
                </div>
                <div class="btn-box">
                  <div class="btn-item" @click.stop="edit_address(item)">
                    编辑
                  </div>
                  <div class="line"></div>
                  <div class="btn-item" @click.stop="del(item.id)">删除</div>
                </div>
              </div>
            </div>
            <div class="add-new-btn" @click="is_popup_show = true">
              新增地址
            </div>
            <div class="select-address-btn" @click="curr_mode = 'custom'">
              确认选择
            </div>
          </div>
        </template>
      </div>
      <div class="footer" v-if="curr_mode != 'add-select'">
        <div class="footer-btn-wrap">
        <div class="price-wrap">
          数量：×{{ count }}
          <span class="shu">|</span>
          制作费用总计：
          <span class="money2">￥{{ total_price | price_format }}</span>
          元
          </div>
          <div v-if="curr_mode === 'custom'" class="btn btn-back" @click="onCancelClick">
            {{ curr_mode === "default" ? "保存草稿" : "返回编辑" }}
          </div>
          <div class="btn btn-confirm" @click="submit">
            {{ curr_mode === "default" ? "提交进行样衣定制" : "确认提交并支付" }}
          </div>
        </div>
        <div class="footer-tips">
          说明:该费用只包含款式基础制作费用,面辅料，打版，印绣花,特殊工艺等,待客服确认后另行支付,敬请知悉!
        </div>
      </div>
    </div>
    <!-- 添加地址弹窗 -->
    <popup
      :show.sync="is_popup_show"
      width="490px"
      height="520px"
      @on-close="close"
    >
      <h2>添加/编辑收货地址</h2>
      <div class="form">
        <div class="form-group">
          <div class="form-label">收货人：</div>
          <div class="form-control">
            <input
              type="text"
              class="input"
              placeholder="请输入收货人"
              v-model="form_address_data.contact_person"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">手机号：</div>
          <div class="form-control">
            <input
              type="text"
              class="input"
              placeholder="请输入手机号"
              v-model="form_address_data.contact_mobile"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">所在地区：</div>
          <div class="form-control">
            <Cascader
              class="input1"
              :data="region"
              v-model="value"
              placeholder="请选择省/市/区/街道"
            ></Cascader>
          </div>
        </div>

        <div class="form-group">
          <div class="form-label">详细地址：</div>
          <div class="form-control">
            <textarea
              placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"
              v-model="form_address_data.address"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="form-label"></div>
          <div class="form-control">
            <input
              type="checkbox"
              v-model="form_address_data.is_default"
            />是否默认地址
          </div>
        </div>
        <div class="btn-submit" @click="saveAddress('formValidate')">
          保存地址
        </div>
      </div>
    </popup>

    <!-- 提交成功弹窗 -->
    <!-- <popup
      :show.sync="is_success_show"
      width="500px"
      height="350px"
      class="bg-white"
      :closeable="false"
      @on-close="is_success_show = false"
    >
      <div class="success-popup">
        <img
          src="../../assets/images/icon-success-free.png"
          alt=""
          class="success-icon"
        />
        <div class="success-title">Submission Successful</div>
        <div class="success-msg">
          Your clothing customization request has been submitted,and we will
          contact you as soon as possible to confirm the details.
        </div>
        <div class="success-btn" @click="onComplete">Complete</div>
      </div>
    </popup> -->
  </div>
</template>
<script>
import { AddressList, DeleteAddress, SaveAddress } from "@/api";
import {
  CheckoutOrder,
  CreateOrder,
  GetDraft,
  ProductCategoryList,
  Profile,
  SaveDraft,
  updateImgList
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import util from "@/utils/util.js";
import { mapState } from "vuex";
const form_address_data = {
  id: 0,
  contact_person: "",
  contact_mobile: "",
  province: "",
  city: "",
  zone: "",
  address: "",
  is_default: 0,
};
export default {
  components: {
    Popup,
  },
  data() {
    return {
      util: util,
      uuid: "",
      sub_product_category_list: [],
      // 所有尺码数据
      raw_size_list: [],
      // 已选尺码KEY
      temp_size_ids: [],
      select_size_ids: [],
      design: {
        cost_list: [],
      },
      complete_list: [],
      table_data: [],
      is_choose_size: false,
      // 主面料A的颜色数据
      raw_color_list: [
        {
          color_id: -1,
          color_key: -1,
          color_name: "Default Color",
          color_name_en: "Default Color",
          color_value: "",
        },
      ],
      // 自定义颜色数据
      custom_color: [],
      temp_color_ids: [],
      // 已选颜色ID
      select_color_ids: [],
      is_add_color: false,
      from: "draft",
      // 仅来自草稿提交时有效
      new_style_no: "",
      is_detail_show: false,
      is_click: false,
      region: region,
      form_data_multiple: [],
      color_list_multiple: [],
      style_list: [],
      remark: "",
      uuids: [],
      address_id: "",
      is_popup_show: false,
      value: [],
      address_list: [],
      form_address_data: {
        id: 0,
        contact_person: '',
        contact_mobile: '',
        province: '',
        city: '',
        zone: '',
        address: '',
        is_default: 0,
      },
      countryList: [],
      stateList: [],
      select_address: {},
      curr_mode: "default",
      is_success_show: false,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      uploading: false,
      uploadQueue: [],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
    };
  },
  watch: {
    address_id(news, olds) {
      if (news != olds) {
        this.select_address = this.address_list.filter((item) => {
          return item.id == news;
        })[0];
      }
    },
    "form_address_data.country": function (e) {
      // this.getStateList();
    },
    "form_data.parent_product_category_id": {
      handler(newVal, oldVal) {
        console.log("base", newVal, oldVal);
        if (newVal > 0) {
          let obj = this.product_category_list.find(
            (v) => v.product_category_id === newVal
          );
          this.sub_product_category_list = obj ? obj.children : [];
          if (oldVal > 0) {
            this.$store.commit("design/update_common", {
              key: "child_product_category_id",
              value: 0,
            });
          }
        }
      },
      immediate: true, // 立即执行一次handler以初始化数据
    },
  },
  computed: {
    ...mapState({
      form_data: (state) => state.design.form_data,
      product_category_list: (state) => state.design.product_category_list,
    }),
    available_color_list() {
      let arr = this.raw_color_list.filter((v) =>
        this.select_color_ids.includes(v.color_id)
      );
      for (let i in this.custom_color.filter((v) =>
        this.select_color_ids.includes(v.color_id)
      )) {
        arr.push(this.custom_color[i]);
      }

      return arr;
    },
    total_price() {
      if (!this.style_list.length) {
        return 0;
      }

      // 根据style_list中的base_price和quantity计算总价
      let totalPrice = 0;
      this.style_list.forEach((item) => {
        // console.log('cpt___item===>',item);
        // 修复判断条件，确保正确处理0值和空字符串
        if (
          item.base_price !== undefined &&
          item.base_price !== null &&
          item.quantity !== undefined &&
          item.quantity !== null
        ) {
          totalPrice +=
            parseFloat(item.factory_price * item.quantity + item.warehouse_fee * 1 + item.kefu_fee * 1);
          totalPrice = parseFloat(totalPrice.toFixed(2))
        }
      });
      console.log("total_price===>", totalPrice);
      // 添加样品费用
      return totalPrice;
    },
    count() {
      let res = 0;
      this.style_list.forEach((item) => {
        res += Number(item.quantity);
      });

      return res;
    },
  },
  async mounted() {
    const { uuid } = this.$route.query;
    if (uuid) {
      this.uuid = uuid;
    }
    await this.getProductCategoryList();
    Promise.all([
      this.onGetDraft(),
      this.getList(),
      // this.getCountryList()
    ]);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("showFooter", false);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
  methods: {
    // validateStyleList() {
    //   // 检查style_list是否为空
    //   if (!this.style_list || this.style_list.length === 0) {
    //     return true;
    //   }

    //   // 遍历style_list中的每一项
    //   for (let i = 0; i < this.style_list.length; i++) {
    //     const item = this.style_list[i];

    //     // 检查每个必填字段是否为空
    //     if (
    //       // 检查父级分类是否选择
    //       !item.parent_product_category_id ||
    //       // 检查样式编号是否填写
    //       !item.style_number ||
    //       // 检查颜色是否填写
    //       !item.color ||
    //       // 检查尺寸是否选择
    //       !item.size ||
    //       // 检查数量是否填写且大于0
    //       !item.quantity ||
    //       parseInt(item.quantity) <= 0
    //     ) {
    //       return false;
    //     }

    //     // 如果有子分类列表且子分类列表不为空，检查是否选择了子分类
    //     if (
    //       item.sub_product_category_list &&
    //       item.sub_product_category_list.length > 0 &&
    //       !item.child_product_category_id
    //     ) {
    //       return false;
    //     }
    //   }

    //   return true;
    // },
    onSizeSelect(value,index){
      // console.log('select-value',value,index);
      this.style_list[index].size = value[value.length-1];
      console.log(this.style_list[index].size,'size');
    },
    validateStyleList() {
      // 检查style_list是否为空
      if (!this.style_list || this.style_list.length === 0) {
        return true;
      }

      // 遍历style_list中的每一项
      for (let i = 0; i < this.style_list.length; i++) {
        const item = this.style_list[i];

        // 检查每个必填字段是否为空
        if (!item.parent_product_category_id) {
          this.$layer.msg(`款式第${i + 1}行：请选择款式分类`);
          return false;
        }

        // 如果有子分类列表且子分类列表不为空，检查是否选择了子分类
        if (
          item.sub_product_category_list &&
          item.sub_product_category_list.length > 0 &&
          !item.child_product_category_id
        ) {
          this.$layer.msg(`款式第${i + 1}行：请选择子分类`);
          return false;
        }

        // if (!item.style_number) {
        //   this.$layer.msg(`款式第${i + 1}行：请输入自定义款号`);
        //   return false;
        // }

        if (!item.color) {
          this.$layer.msg(`款式第${i + 1}行：请输入颜色`);
          return false;
        }

        if (!item.size) {
          this.$layer.msg(`款式第${i + 1}行：请选择尺码`);
          return false;
        }

        if (!item.quantity || parseInt(item.quantity) <= 0) {
          this.$layer.msg(`款式第${i + 1}行：请输入正确的数量`);
          return false;
        }
      }

      return true;
    },
    onCancelClick() {
      const { curr_mode } = this;
      if (curr_mode === "default") {
        this.$router.back();
        return;
      }
      if (curr_mode === "custom") {
        this.curr_mode = "default";
        return;
      }
    },
    async onSave() {
      // TODO 保存,获取UUID,跳转新的SUMMARY
      try {
        if (this.is_click) {
          return;
        }
        this.is_click = true;
        console.log("form_data", this.form_data);
        if (!this.form_data.image_list.length) {
          this.$layer.msg("请上传设计稿");
          return;
        }
        // return;
        const { data } = await updateImgList({
          uuid: this.uuid,
          image_list: this.design.image_list,
        });
        if (!data.uuid) {
          this.$layer.msg("操作失败,请稍后重试[UUID]");
          return;
        }
        this.$layer.msg("操作成功");
      } catch (e) {
        console.log("e", e);
      } finally {
        this.is_click = false;
      }
    },
    deleteImage(index) {
      this.design.image_list.splice(index, 1);
    },
    async processAllFiles() {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`Startting upload ${queue.length} files...`);

      for (const file of queue) {
        try {
          const url = await uploadFileToOSS(file, "template");
          // this.image_list.push({raw:url,raw_name:file.name});
          const object = { raw: url, raw_name: file.name };
          this.design.image_list.push(object);
          console.log("image_list", this.design.image_list);
          // console.log('this.image_list',this.image_list);
        } catch (err) {
          this.$layer.msg(`上传失败：${file.name}`);
        }
      }
    },
    onBeforeUpload(file) {
      console.log("file-before", file);
      this.uploading = true;
      // 将文件加入队列
      this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
        this.processAllFiles();
      }, this.debounceTime);
      return false;
    },
    onComplete() {
      this.is_success_show = false;
      this.$router.push({ name: "OrderCenter" });
    },
    reset() {
      this.form_address_data = { ...form_address_data };
      this.value = [];
    },
    saveAddress() {
      this.form_address_data.province = this.value[0];
      this.form_address_data.city = this.value[1];
      this.form_address_data.zone = this.value[2];
      SaveAddress(this.form_address_data)
        .then(() => {
          this.$layer.msg(`保存成功`);
          this.reset();
          this.is_popup_show = false;
        })
        .finally(() => {
          this.getList();
        });
    },
    close() {
      this.is_popup_show = false;
    },
    edit_address(item) {
      this.form_address_data = item;
      this.value = [
        this.form_address_data.province,
        this.form_address_data.city,
        this.form_address_data.zone,
      ];
      this.is_popup_show = true;
    },
    del(id) {
      this.$DModal.confirm({
        content: "是否确认删除这个地址?",
        okText: "确认",
        cancelText: "取消",
        onOK: () => {
          DeleteAddress({ id })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.getList();
            });
        },
      });
    },
    async getList() {
      return AddressList().then((response) => {
        this.address_list = response.data;
        this.address_list.forEach((item) => {
          if (item.is_default) {
            this.address_id = item.id;
          }
        });
        return response.data;
      });
    },
    onDeleteStyle(index) {
      this.style_list.splice(index, 1);
      console.log("onDelete_style", this.style_list);
    },
    onChangeParentCategory(value, data, index) {
      console.log("value===>", value);
      console.log("data====>", data);
      console.log("index====>", index);
      const child = data.filter((item) => {
        return item.product_category_id == value;
      })[0];
      console.log("child==>", child);
      let size_group_list = child.size_group_list.map(item=>{
         return {
            value:item.key,
            label:item.name,
            children:item.group.map(i=>{
              return {
                value:i.id,
                label:i.name,
                children:i.size_list.map(s=>{
                  return{
                    value:s,
                    label:s
                  }
                })
              }
            })
         }
      })
      this.style_list[index].sub_product_category_list = [...child.children];
      this.style_list[index].size_list = size_group_list;
      this.style_list[index].parent_cate_name = child.category_name_cn;
      this.style_list[index].base_price = child.base_price;
      this.style_list[index].times = Number(child.times) ? child.times : 1;
      this.style_list[index].parent_product_category_id = value;
      this.style_list[index].factory_price = parseFloat(Math.ceil(this.style_list[index].base_price * ((1 + this.$store.state.setting.tax_ratio/100) * (1 + this.$store.state.setting.sample_profit_ratio/100)) * this.style_list[index].times))
      this.style_list[index].warehouse_fee = 0;
      this.style_list[index].kefu_fee = 0;
      let raw = Array.from(this.$store.state.setting.kw_price)
      let arr = Array.isArray(raw) ? raw.reverse() : []
      for(let i in arr) {
        if(Number(arr[i].min) < this.style_list[index].base_price && this.style_list[index].base_price <= Number(arr[i].max)) {
          this.style_list[index].warehouse_fee = Math.ceil(arr[i]?.sample_warehouse_fee);
          this.style_list[index].kefu_fee = Math.ceil(arr[i]?.sample_kefu_fee);
          break;
        }
      }
    },
    onChangeSubCategory(value, data, index) {
      console.log("child-value===>", value);
      console.log("child-data====>", data);
      console.log("child-index====>", index);
      const res = data.filter((item) => {
        return item.product_category_id == value;
      })[0];
      const parent = this.product_category_list.filter((item)=>{
        return item.product_category_id == res.parent_id;
      })[0];
      // console.log("resssss=>", res);
      let size_group_list = res.size_group_list.map(item=>{
        //  console.log('item',item);
         return {
            value:item.key,
            label:item.name,
            children:item.group.map(i=>{
              return {
                value:i.id,
                label:i.name,
                children:i.size_list.map(s=>{
                  return{
                    value:s,
                    label:s
                  }
                })
              }
            })
         }
      })
      this.style_list[index].size_list = size_group_list;
      // this.style_list[index].size_list = [...new Set([...res.size_list_man, ...res.size_list_woman])];
      this.style_list[index].child_cate_name = res.category_name_cn;
      if(res.base_price && res.base_price>0){
        this.style_list[index].base_price = res.base_price;
      }else{
        /**
         * 第一次选择的二级有base_price但是新的二级没有base_price
         * 需要重新从父级获取base_price
         */

        this.style_list[index].base_price = parent.base_price;
      }
      this.style_list[index].times = Number(res.times) ? res.times : parent.times;
      this.style_list[index].factory_price = parseFloat(Math.ceil(this.style_list[index].base_price * ((1 + this.$store.state.setting.tax_ratio/100) * (1 + this.$store.state.setting.sample_profit_ratio/100)) * this.style_list[index].times))
      this.style_list[index].child_product_category_id = value;
      this.style_list[index].warehouse_fee = 0;
      this.style_list[index].kefu_fee = 0;
      let raw = Array.from(this.$store.state.setting.kw_price)
      let arr = Array.isArray(raw) ? raw.reverse() : []
      for(let i in arr) {
        if(Number(arr[i].min) < this.style_list[index].base_price && this.style_list[index].base_price <= Number(arr[i].max)) {
          this.style_list[index].warehouse_fee = Math.ceil(arr[i]?.sample_warehouse_fee);
          this.style_list[index].kefu_fee = Math.ceil(arr[i]?.sample_kefu_fee);
          break;
        }
      }
      console.log(999, this.style_list[index])
    },
    onAddmoreStyle() {
      if (!this.validateStyleList()) {
        // setTimeout(()=>{
        //   // this.$layer.msg("请确保所有项目都已填写");
        // },1500);
        return;
      }
      const uuid = util.uuid();
      console.log("style_list", this.style_list);
      this.style_list.push({
        uuid: uuid,
        style_number: "",
        color: "",
        size: "",
        quantity: 1,
        parent_product_cate_list: [...this.product_category_list],
        sub_product_category_list: [],
        size_list: [],
        parent_product_category_id: "",
        child_product_category_id: "",
        base_price: 0,
        factory_price: 0,
        warehouse_fee: 0,
        kefu_fee: 0,
        times: 1
      });
    },
    onChangeSize(e) {
      console.log("e===>", e);
    },
    async onGetDraft() {
      try {
        const { data } = await GetDraft({ uuid: this.$route.query.uuid });
        console.log("draft-data-mounted", data);
        this.design = data;
        this.remark = data.description;
        if (!data.children.length) {
          this.onAddmoreStyle();
          return;
        }
        const origin_data = this.style_list;
        this.style_list = data.children.map((item,index) => {
          console.log("item===>", item);
          let sub_cate = [];
          if (item.child_product_category_id) {
            sub_cate = this.product_category_list.filter((i) => {
              return i.product_category_id == item.parent_product_category_id;
            })[0]["children"];
          }
          let parent_cate = this.product_category_list.filter((i) => {
            return item.parent_product_category_id == i.product_category_id;
          })[0]
          // console.log('parent_cate',parent_cate);
          let parent_size_list = []
          if (parent_cate) {
            // const manList = Array.isArray(parent_cate.size_list_man) ? parent_cate.size_list_man : [];
            // const womanList = Array.isArray(parent_cate.size_list_woman) ? parent_cate.size_list_woman : [];
            // parent_size_list = [...manList, ...womanList];
            parent_size_list = parent_cate.size_group_list.map(item=>{
              // console.log('item',item);
              return {
                  value:item.key,
                  label:item.name,
                  children:item.group.map(i=>{
                    return {
                      value:i.id,
                      label:i.name,
                      children:i.size_list.map(s=>{
                        return{
                          value:s,
                          label:s
                        }
                      })
                    }
                  })
              }
            })
          }
          let child_size_list = [];
          // console.log('subcate',sub_cate);
          if (sub_cate.length) {
            // console.log('enter-sub');
            let curr_sub_cate = sub_cate.filter((ci)=>{
              return ci.product_category_id == item.child_product_category_id;
            })[0]
            // console.log('curr_sub_cate',curr_sub_cate);
            // const sub_man_list = Array.isArray(curr_sub_cate.size_list_man) ? curr_sub_cate.size_list_man : [];
            // console.log('sub-man',sub_man_list,curr_sub_cate.size_list_man);
            // const sub_woman_list = Array.isArray(curr_sub_cate.size_list_woman) ? curr_sub_cate.size_list_woman : [];
            // console.log('suhb-woman',sub_woman_list,curr_sub_cate.size_list_woman);
            // child_size_list = [...sub_man_list, ...sub_woman_list];
            child_size_list = curr_sub_cate.size_group_list.map(item=>{
              // console.log('item',item);
              return {
                  value:item.key,
                  label:item.name,
                  children:item.group.map(i=>{
                    return {
                      value:i.id,
                      label:i.name,
                      children:i.size_list.map(s=>{
                        return{
                          value:s,
                          label:s
                        }
                      })
                    }
                  })
              }
            })
          }
          let local_data = {};
          if(origin_data.length>0){
            local_data = origin_data[index];
          }

          let base_price = 0;
          const parentCategory = this.product_category_list.find(i => i.product_category_id == item.parent_product_category_id);
          base_price = parentCategory.base_price;
          if(item.child_product_category_id){
            const childCategory = parentCategory.children.find(i => i.product_category_id == item.child_product_category_id);
            if(childCategory.base_price>0){
              base_price = childCategory.base_price;
            }
          }
          console.log('child_size_list_length',child_size_list.length,child_size_list);
          return {
            uuid: item.key,
            parent_product_cate_list: [...this.product_category_list],
            sub_product_category_list:
              sub_cate && sub_cate.length > 0 ? sub_cate : [],
            parent_product_category_id: item.parent_product_category_id,
            child_product_category_id: item.child_product_category_id,
            style_number: item.name,
            size_list:
              child_size_list.length > 0 ? child_size_list : parent_size_list,
            quantity: local_data.quantity || 1,
            color: local_data.color || "",
            size: local_data.size || "",
            size_cascader: local_data.size_cascader || [],
            parent_cate_name: this.product_category_list.filter((i) => {
              return i.product_category_id == item.parent_product_category_id;
            })[0]["category_name_cn"],
            child_cate_name: item.child_product_category_id
              ? sub_cate.filter((i) => {
                  return (
                    i.product_category_id == item.child_product_category_id
                  );
                })[0]["category_name_cn"]
              : "",
            base_price:  parseFloat(base_price),
          };
        });
        console.log("style_list", this.style_list);
      } catch (e) {
        console.log("e===>getDraft", e);
      }
    },
    async onUpdateInfo() {
      try {
        console.log('style-list-upd',this.style_list);
        const img = this.design.image_list.filter((item) => {
          const name = item.raw_name.split(".").pop();
          return ["jpg", "jpeg", "png", "webp", "gif"].includes(name);
        })[0];
        const { data } = await SaveDraft({
          uuid: this.uuid,
          scene: "bc",
          from: "fast",
          is_multiple: "1",
          image: img && img.raw ? img.raw : "",
          image_list: this.design.image_list,
          description: this.remark,
          children: this.style_list.map((item) => {
            return {
              key: item.uuid,
              name: item.style_number,
              product_category_id: item.child_product_category_id
                ? item.child_product_category_id
                : item.parent_product_category_id,
              parent_product_category_id: item.parent_product_category_id,
              child_product_category_id: item.child_product_category_id,
              image_list: this.design.image_list,
              image: img && img.raw ? img.raw : "",
            };
          }),
        });
        console.log("data===>", data);
        // this.onGetDraft();
      } catch (e) {
        console.log("e--->save_draft", e);
      }
    },
    submit() {
      if (this.is_click) {
        return;
      }
      console.log("this.style_list", this.style_list);

      if (!this.design.image_list.length) {
        this.$layer.msg("请上传图片或文件");
        return;
      }

      if (!this.validateStyleList()) {
        // this.$layer.msg("请完善当前新增的款式内容");
        return;
      }

      if (!this.style_list.length || this.style_list.length < 1) {
        this.$layer.msg("请至少添加一个款式");
        return;
      }

      const img = this.design.image_list.filter((item) => {
        const name = item.raw_name.split(".").pop();
        return ["jpg", "jpeg", "png", "webp", "gif"].includes(name);
      })[0];

      const data = {};
      const color = {};

      this.style_list.forEach((item) => {
        const color_uuid = util.uuid();

        // 确保 data[item.uuid] 存在
        if (!data[item.uuid]) {
          data[item.uuid] = {};
        }

        const parent_cate_name = this.product_category_list.filter((i) => {
          return i.product_category_id == item.parent_product_category_id;
        })[0]["category_name_cn"];

        const child_cate_name = item.child_product_category_id
          ? item.sub_product_category_list.filter((i) => {
              return (
                i.product_category_id == item.child_product_category_id
              );
            })[0]["category_name_cn"]
          : "";

        // 设置 category 信息
        data[item.uuid]["category"] = {
          product_category_id: item.child_product_category_id
            ? item.child_product_category_id
            : item.parent_product_category_id,
          parent_product_category_id: item.parent_product_category_id,
          child_product_category_id: item.child_product_category_id,
          product_category_name:`${parent_cate_name}${child_cate_name ? `-${child_cate_name}` : ""}`,
          name:child_cate_name ? child_cate_name : parent_cate_name,
          style_number: item.style_number,
          image_list: this.design.image_list,
          key: item.uuid,
          image: img && img.raw ? img.raw : "",
        };

        // 确保 table_data 对象存在
        if (!data[item.uuid]["table_data"]) {
          data[item.uuid]["table_data"] = {};
        }

        // 确保特定尺寸的对象存在
        if (!data[item.uuid]["table_data"][item.size]) {
          data[item.uuid]["table_data"][item.size] = {};
        }

        // 设置 table_data 信息
        data[item.uuid]["table_data"][item.size] = {
          size: {
            size_key: item.size,
            size_alias: item.size,
          },
          color: {
            [color_uuid]: {
              color_id: color_uuid,
              color_key:color_uuid,
              color_name: item.color,
              color_name_cn: item.color,
              quantity: item.quantity,
              type: 1,
              color_value: "",
            },
          },
          complete: {},
        };

        if (!data[item.uuid]["select_size_ids"]) {
          data[item.uuid]["select_size_ids"] = [];
        }

        data[item.uuid]["select_size_ids"].push(item.size);

        if (!data[item.uuid]["select_color_ids"]) {
          data[item.uuid]["select_color_ids"] = [];
        }

        data[item.uuid]["select_color_ids"].push(color_uuid);

        // 设置 color 信息
        if (!color[item.uuid]) {
          color[item.uuid] = {};
        }

        color[item.uuid] = [
          {
            color_id: color_uuid,
            color_key:color_uuid,
            color_name: item.color,
            color_name_cn: item.color,
            color_value: "",
            type: 1,
          },
        ];
      });
      console.log("data", data);
      console.log("color", color);
      this.form_data_multiple = data;
      this.color_list_multiple = color;
      // return;
      if (this.curr_mode === "default") {
        if (!this.address_id) {
          this.$layer.msg("请选择地址");
          return;
        }
        // const param = {};
        // param.from = "draft";
        // param.uuid = this.uuid;
        // param.form_data_multiple = data;
        // param.color_list_multiple = color;
        // console.log("param-before", param);
        this.curr_mode = "custom";
        console.error('onUpdateInfo')
        this.onUpdateInfo();

        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
        return;
      }

      // return;
      if (this.count < 1) {
        this.$layer.msg(
          `请输入所需定制服装的数量`
        );
        return;
      }

      this.confirm_submit();
    },
    extractCategoryArray() {
      const categoryArray = [];

      // 遍历form_data_multiple对象
      for (const key in this.form_data_multiple) {
        // if (this.form_data_multiple.hasOwnProperty(key) && this.form_data_multiple[key].category) {
        if(Object.prototype.hasOwnProperty.call(this.form_data_multiple,key) && this.form_data_multiple[key].category){
          const category = this.form_data_multiple[key].category;
          categoryArray.push({
            parent_product_category_id: category.parent_product_category_id,
            child_product_category_id: category.child_product_category_id,
            product_category_id: category.product_category_id
          });
        }
      }

      return categoryArray;
    },
    async confirm_submit() {
      const param = {};
      param.from = this.from;
      param.is_fast = 1;
      param.new_style_no = this.new_style_no;
      param.form_data_multiple = this.form_data_multiple;
      param.color_list_multiple = this.color_list_multiple;
      param.uuid = this.$route.query.uuid;
      param.sample_extra = this.form_data_sample;
      console.log("param", param);
      //   return;
      this.is_click = true;
      this.$Spin.show();
      const product_category = this.extractCategoryArray();
      console.log('product_category',product_category);
      // return;
      CreateOrder(param)
        .then((response) => {
          if (response.code > 0) {
            this.$layer.msg(response.msg);
            this.$Spin.hide();
            return;
          }
          const { address_id } = this;
          const { uuid } = response.data;
          return CheckoutOrder({ uuid, address_id,from:'fast',category:product_category });
        })
        .then((res) => {
          this.$router.push({
            name: "CashDesk",
            query: { uuid: res.data.uuid, pay_type: "wechat",from:'quick' },
          });
          // return PayOrder({pay_type:'free',uuid: res.data.uuid})
        })
        .then(() => {
          this.is_success_show = true;
        })
        .catch((res) => {
          console.log("err", res);
          this.$layer.msg(res);
        })
        .finally(() => {
          this.$Spin.hide();
          setTimeout(() => {
            this.is_click = false;
          }, 500);
        });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    show_detail() {
      this.is_detail_show = true;
    },
    blur($e, v) {
      let temp = $e.target.value;
      if (isNaN(temp)) {
        v.val = v.normal;
      }
      temp = parseFloat(temp);
      if (temp < parseFloat(v.normal) + parseFloat(v.min)) {
        v.val = parseFloat(v.normal) + parseFloat(v.min);
      }
      if (temp > parseFloat(v.normal) + parseFloat(v.max)) {
        v.val = parseFloat(v.normal) + parseFloat(v.max);
      }
      v.val = Math.round(v.val * 10) / 10;
    },
    onAddColor(e) {
      console.log("add-color", e.target.value);
      const id = util.uuid();
      const color = e.target.value;
      const checkRepeat = this.raw_color_list.findIndex(
        (item) => item.color_name == color
      );
      console.log("check===>", checkRepeat);
      if (checkRepeat != -1) {
        this.$layer.msg("颜色已存在");
        return;
      }
      this.raw_color_list.push({
        color_id: id,
        color_key: id,
        color_name: color,
        color_name_en: color,
        color_value: "",
      });
      if (!this.temp_color_ids.includes(id)) {
        this.temp_color_ids.push(id);
        this.select_color_ids.push(id);
      }
      this.is_add_color = false;

      // 更新所有已存在的表格行，添加新颜色列
      for (let sizeKey in this.table_data) {
        let colorObj = this.available_color_list.find((v) => v.color_id === id);
        if (colorObj && !this.$_.has(this.table_data[sizeKey].color, id)) {
          this.$set(this.table_data[sizeKey].color, id, {
            ...colorObj,
            quantity: 0,
          });
        }
      }
      console.log("raw-color-list", this.raw_color_list);
      console.log("temp_color_ids", this.temp_color_ids);
      console.log("select_color_ids", this.select_color_ids);
    },
    onCancelChooseSize() {
      this.temp_size_ids = [];
      this.is_choose_size = false;
    },
    onSizeChoose(e) {
      console.log("on_size_choose", e);
    },
    choose_size(size_key, is_delete = true) {
      let shouldCreateRow = false;

      if (is_delete && this.select_size_ids.includes(size_key)) {
        this.select_size_ids = this.select_size_ids.filter((item) => {
          return item !== size_key;
        });
      } else {
        console.log("aaaa", size_key);
        if (!this.select_size_ids.includes(size_key)) {
          this.select_size_ids.push(size_key);
          this.select_size_ids = [...new Set(this.select_size_ids)];
          shouldCreateRow = true;
        }
      }

      console.log("this.select_size_ids", this.select_size_ids);
      let obj = this.table_data;

      if (is_delete && this.$_.has(obj, size_key)) {
        delete obj[`${size_key}`];
        this.$set(this, "table_data", obj);
      } else if (shouldCreateRow || !is_delete) {
        // 确保在非删除模式下也会创建行
        let temp_color = {};
        for (let ii in this.select_color_ids) {
          let color = this.available_color_list.find(
            (v) => v.color_id === this.select_color_ids[ii]
          );
          temp_color[this.select_color_ids[ii]] = { ...color, quantity: 0 };
        }

        let temp_complete = this.$_.cloneDeep(
          this.design?.pat?.size_info[size_key] || {}
        );
        if (this.design.pattern_type === 3) {
          // 定制版型情况
          temp_complete = this.$_.cloneDeep(
            this.design?.productcategory?.size_info[size_key] || {}
          );
        }
        for (let i in temp_complete) {
          if (!this.$_.has(temp_complete[i], "val")) {
            temp_complete[i].val = temp_complete[i].normal;
          }
        }

        this.$set(
          this.table_data,
          size_key,
          this.$_.cloneDeep({
            size: { size_key: size_key, size_alias: size_key },
            color: temp_color,
            complete: temp_complete,
            sort: this.raw_size_list.findIndex((v) => v === size_key),
          })
        );
      }

      const map = new Map(
        Object.entries(this.table_data).sort(function (a, b) {
          return a[1].sort - b[1].sort;
        })
      );
      this.$set(this, "table_data", Object.fromEntries(map));

      // 确保所有颜色列都正确显示
      this.ensureAllColorColumns();
    },
    ensureAllColorColumns() {
      // 确保 table_data 中的每一行都包含所有已选颜色
      for (let sizeKey in this.table_data) {
        let row = this.table_data[sizeKey];
        for (let i in this.select_color_ids) {
          let colorId = this.select_color_ids[i];
          if (!this.$_.has(row.color, colorId)) {
            let color = this.available_color_list.find(
              (v) => v.color_id === colorId
            );
            if (color) {
              this.$set(row.color, colorId, { ...color, quantity: 0 });
            }
          }
        }
      }
    },
    change1($event, field) {
      switch (field) {
        case "parent_product_category_id": {
          const find_index = this.product_category_list.findIndex(
            (item) =>
              Number(item.product_category_id) === Number($event.target.value)
          );
          if (find_index != -1) {
            this.curr_package_detail =
              this.product_category_list[find_index].package_detail || [];
            this.raw_size_list =
              this.product_category_list[find_index].size_list;
            let s =
              this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
            this.choose_size(s);
            this.complete_list =
              this.product_category_list[find_index].complete_list;
            this.$store.commit("design/update_common", {
              key: "package_detail",
              value: this.curr_package_detail,
            });
          }
          break;
        }
        case "child_product_category_id": {
          const find_index = this.sub_product_category_list.findIndex(
            (item) =>
              Number(item.product_category_id) === Number($event.target.value)
          );
          if (find_index != -1) {
            if (
              this.sub_product_category_list[find_index].package_detail &&
              this.sub_product_category_list[find_index].package_detail.length >
                0
            ) {
              this.package_detail =
                this.sub_product_category_list[find_index].package_detail;
              if (
                this.sub_product_category_list[find_index].size_list.length > 0
              ) {
                this.raw_size_list =
                  this.sub_product_category_list[find_index].size_list;
                let s =
                  this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
                this.choose_size(s);
              }
              if (
                this.sub_product_category_list[find_index].complete_list
                  .length > 0
              ) {
                this.complete_list =
                  this.sub_product_category_list[find_index].complete_list;
              }
              this.$store.commit("design/update_common", {
                key: "package_detail",
                value: this.curr_package_detail,
              });
            }
            // this.onUpdateInfo();
          }
          break;
        }
      }

      console.log("raw-size-list", this.raw_size_list);
      this.$store.commit("design/update_common", {
        key: field,
        value: parseInt($event.target.value),
      });

      // this.onUpdateInfo();
    },
    async getProductCategoryList() {
      const { data } = await ProductCategoryList();
      this.$store.commit("design/set_product_category_list", data);
    },
  },
};
</script>
<style lang="scss" scoped>
.quick-design-page {
  width: 100%;
  min-height: 100vh;
  background: rgb(245, 246, 245);
  // padding-bottom:200px;
  // margin-bottom:200px;
  display: flex;
  justify-content: center;
  .design-body {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-top: 8px;
    .step-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 22px;
      .step-title {
        display: flex;
        align-items: center;
        column-gap: 10px;
        .step-num {
          width: 20px;
          height: 20px;
          background: #1a1a1a;
          border-radius: 5px;
          line-height: 20px;
          text-align: center;
          color: #ffffff;
          font-size: 14px;
        }
        .step-name {
          color: #333333;
          font-size: 18px;
          font-weight: 500;
        }
      }
      .step-desc {
        color: #999999;
        font-size: 13px;
      }
    }
    .design-color-size-quantity {
      width: 100%;
      background: #ffffff;
      padding: 32px 40px 32px 30px;
      .top-title {
        width: 100%;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        padding-bottom: 18px;
        border-bottom: 1px solid #ebebeb;
      }
      .style-box {
        width: 100%;
        margin-top: 25px;
        display: flex;
        align-items: center;
        flex-direction: column;
        row-gap: 8px;
        // column-gap: 10px;
        .label-box {
          display: flex;
          align-items: center;
          width: 100%;
          font-weight: bold;
          font-size: 14px;
          padding: 0 10px;
          column-gap: 10px;
          color: #666666;
          .type-label {
            width: 100%;
            max-width: 300px;
          }
          .number-label {
            width: 100%;
            max-width: 150px;
          }
          .color-label {
            width: 100%;
            max-width: 150px;
          }
          .size-label {
            width: 100%;
            max-width: 150px;
          }
          .quantity-label {
            width: 100%;
            max-width: 150px;
          }
          .price-label {
            width: 100%;
            max-width: 150px;
            text-align: center;
          }
          .operation-label {
            width: 100%;
            max-width: 30px;
          }
        }
        .form-item {
          width: 100%;
          background: #fafafa;
          display: flex;
          align-items: center;
          column-gap: 10px;
          padding: 15px 10px;
          margin-top: 10px;
          .type-box,
          .number-box,
          .color-box,
          .size-box,
          .quantity-box {
            border: 1px solid #dad5d1;
            background: #ffffff;
            height: 52px;
            border-radius: 5px;
            width: 100%;
            overflow: hidden;
            input {
              border: none;
              outline: none;
              width: 100%;
              height: 100%;
              padding: 0 5px;

              &::placeholder{
                color:#b3b3b3;
              }

              &::-webkit-input-placeholder{
                color:#b3b3b3;
              }

              &::-moz-placeholder{
                color:#b3b3b3;
              }

              &:-ms-input-placeholder{
                color:#b3b3b3;
              }
            }
          }
          .type-box {
            max-width: 260px;
            display: flex;
            align-items: center;
            .type-item {
              flex: 1;
              height: 100%;
              // &:first-child {
                // border-right:1px solid #dad5d1;
              // }
              &:last-child {
                border-left: 1px solid #dad5d1;
              }
              // padding: 0 18px;
              select {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                option {
                  color: #333333;
                  &.placeholder-option,
                  &[value=""] {
                    color: #b3b3b3 !important;
                  }
                }
              }
            }
          }
          .number-box {
            max-width: 150px;
          }
          .color-box,
          .size-box {
            max-width: 150px;
          }
          .size-box {
            padding: 0 5px;
            select {
              border: none;
              outline: none;
              width: 100%;
              height: 100%;
              option {
                color: #333333;
                &.placeholder-option,
                &[value=""] {
                  color: #b3b3b3 !important;
                }
              }
            }
          }
          .quantity-box {
            max-width: 150px;
          }
          .price-box {
            max-width: 150px;
            width: 100%;
            text-align: center;
            color:#1a1a1a;
          }
          .del-ico {
            width: 20px;
            height: 20px;
            cursor: pointer;
            text-align: right;
            margin-left: 1%;
          }
        }
        .style-number {
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          .label {
            color: #1a1a1a;
            font-size: 15px;
            font-weight: 500;
          }
          .input {
            width: 150px;
            height: 52px;
            border-radius: 5px;
            border: 1px solid #dad5d1;
            padding: 0 18px;
          }
        }
        .type-select {
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          width: 100%;
          max-width: 300px;
          .label {
            color: #1a1a1a;
            font-size: 15px;
            font-weight: 500;
          }
          .input-box {
            display: flex;
            align-items: center;
            // column-gap: 5px;
            height: 52px;
            .select-item {
              flex: 1;
              height: 100%;
              border-radius: 5px;
              border: 1px solid #dad5d1;
              padding: 0 18px;
              select {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                option {
                  color: #333333;
                  &.placeholder-option,
                  &[value=""] {
                    color: #b3b3b3 !important;
                  }
                }
              }
            }
          }
        }
      }
      .add-more-btn {
        width: 100%;
        // border-bottom: 1px solid #e5e5e5;
        // padding-bottom: 27px;
        margin-top: 20px;
        .more-btn {
          display: flex;
          align-items: center;
          column-gap: 8px;
          margin-left: 10px;
          width: fit-content;
          cursor: pointer;
          .add-ico {
            width: 18px;
            height: 18px;
          }
          .btn-text {
            font-size: 14px;
            color: #666666;
          }
        }
      }
      .note-info-title {
        width: 100%;
        // margin-top: 25px;
        font-weight: bold;
        color: #333333;
        font-size: 14px;
        margin-left: 10px;
      }
      .note-info-box {
        width: 100%;
        padding: 13px 10px 0 10px;
        .note-box {
          width: 100%;
          height: 110px;
          border-radius: 5px;
          border: 1px solid #dad5d1;
          overflow: hidden;
          textarea {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            padding: 10px;
            &::placeholder{
              color:#b3b3b3 !important;
            }
            &::-webkit-input-placeholder{
              color:#b3b3b3 !important;
            }
            &:-moz-placeholder{
              color:#b3b3b3 !important;
            }
            &:-ms-input-placeholder{
              color:#b3b3b3 !important;
            }
          }
        }
      }

      .label-title {
        color: #1a1a1a;
        font-size: 15px;
        font-weight: 500;
        margin-top: 40px;
      }

      .table {
        width: 100%;
        margin-top: 10px;
        table-layout: fixed;
        text-align: center;
        border-collapse: collapse;
        display: block;
        overflow-x: auto;
        white-space: nowrap;
        border-right: 1px solid #e2e5e9;
        box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.1);

        th,
        td {
          box-sizing: border-box;
        }

        th:first-child,
        td:first-child {
          position: sticky;
          left: 0;
          z-index: 10;
          background: #f8f8f9;
        }

        .size {
          width: 160px;
        }
        .color {
          width: 130px;
        }

        .complete {
          width: 130px;
        }
        .input {
          text-align: center;
          outline: none;
          border: 1px solid #e2e5e9;
          width: 100%;
        }

        th {
          padding: 0 5px;
          height: 50px;
          line-height: 50px;
          background: #f5f5f5;
          border: 1px solid #e2e5e9;

          &.color {
            color: #fa3d5a;
          }
          .icon-edit {
            width: 12px;
            height: 12px;
            margin: 0 10px;
          }
        }

        td {
          padding: 2px 5px;
          height: 50px;
          line-height: 50px;
          border: 1px solid #e2e5e9;
          font-size: 15px;
          .icon-edit {
            width: 12px;
            height: 12px;
            margin: 0 10px;
          }
        }
      }
    }
    .pick-address-box {
      width: 1200px;
      background: #ffffff;
      padding: 32px 40px 50px 40px;
      .pick-title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        padding-bottom: 24px;
        // border-bottom: 1px solid #e5e5e5;
      }
      .address-list {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 10px;
        column-gap: 16px;

        .item-box {
          display: flex;
          align-items: center;
          padding: 20px;
          // margin-top: 30px;
          flex: 0 0 49%;
          min-width: 0;
          background: #fafafa;
          border-radius: 5px;
          position: relative;
          &.active {
            border: 1px solid #fe5866;
          }
          .selected-icon {
            border-radius: 50%;
            background: #fe5866;
            width: 22px;
            height: 22px;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            position: absolute;
            top: 10px;
            right: 10px;
          }
          .address-item {
            display: flex;
            flex-direction: column;
            line-height: 1.5;
            // height:3em;
            margin-left: 10px;
            width: 100%;
            cursor: pointer;
            .name {
              color: #333333;
              font-size: 16px;
              font-weight: 500;
              span {
                background: rgba(254, 88, 102, 0.12);
                border-radius: 10px;
                color: #fe5866;
                font-size: 12px;
                padding: 5px 12px;
              }
            }
            .address,
            .phone {
              color: #333333;
              font-size: 14px;
              line-height: 1.5;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
              min-width: 0;
              margin-top: 13px;
            }
            .btn-box {
              display: flex;
              align-items: center;
              margin-top: 20px;
              .btn-item {
                color: #808080;
                font-size: 12px;
                cursor: pointer;
                &:first-child {
                  padding-right: 15px;
                }
                &:last-child {
                  padding-left: 15px;
                }
                &:hover {
                  color: #fe5866;
                  text-decoration: underline;
                }
              }
              .line {
                width: 1px;
                height: 15px;
                background: #808080;
              }
            }
          }
        }
      }
      .add-btn {
        width: 280px;
        height: 52px;
        margin-top: 30px;
        border: 1px dashed #dad5d1;
        // border-radius: 26px;
        // text-align: center;
        // line-height: 52px;
        color: #666666;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 15px;
          height: 15px;
        }
      }
    }
    .design-img-list {
      width: 1200px;
      background: #ffffff;
      padding: 32px 40px 50px 40px;
      margin-bottom: 200px;
      .list-title {
        color: #333333;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 36px;
      }
      .img-list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .img-item {
          width: 150px;
          height: 150px;
          border: 1px solid #ebebeb;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .remove-icon {
            width: 22px;
            height: 22px;
            position: absolute;
            top: 5px;
            right: 5px;
          }
        }
        .upload-icon {
          width: 150px;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
    .custom-order-details {
      width: 100%;
      background: #ffffff;
      padding: 30px 40px 50px 30px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 200px;
      }
      .detail-title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        &.title-line {
          padding-bottom: 14px;
          border-bottom: 1px solid #e5e5e5;
        }
      }
      .details-list {
        width: 100%;
        border-bottom: 1px solid #e5e5e5;
        display: flex;
        justify-content: flex-end;
        align-items: end;
        flex-direction: column;
        row-gap: 20px;
        margin-top: 40px;
        padding-bottom: 40px;
        // flex-wrap:wrap;
        .list-wrap {
          margin-right: 50px;
          display: flex;
          column-gap: 20%;
          // width:100%;
          width: 400px;
          justify-content: end;

          .list-label {
            color: #1a1a1a;
            font-size: 14px;
            flex: 1;
            text-align: left;
            // width:fit-content;
            white-space: nowrap;
            flex-shrink: 1;
          }
          .list-value {
            color: #1a1a1a;
            font-size: 14px;
            // flex:1;
            text-align: right;
            white-space: nowrap;
            flex-shrink: 1;
          }
        }
      }
      .final-price {
        display: flex;
        align-items: end;
        justify-content: flex-end;
        flex-direction: column;
        width: 100%;
        margin-top: 30px;
        .price-wrap {
          width: 400px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          column-gap: 20%;
          margin-right: 50px;
          .price-label {
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            text-align: left;
            flex: 1;
            flex-shrink: 1;
            white-space: nowrap;
          }
          .price-value {
            color: #fa3d5a;
            font-size: 24px;
            font-weight: bold;
            // flex:1;
            flex-shrink: 1;
          }
        }
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
        margin-bottom: 40px;

        th,
        td {
          border-right: none;
          border-left: none;
          border-top: 1px solid #e2e5e9;
          border-bottom: 1px solid #e2e5e9;
          padding: 12px 8px;
          text-align: left;
        }

        thead th {
          background-color: #f5f5f5;
          color: #666666;
          font-size: 14px;
          text-align: left;
          font-weight: bold;
          border-top: none;
        }

        // 移除 tbody 中单元格的上边框，只保留下边框
        tbody td {
          border-top: none;
          text-align: left;
          color: #1a1a1a;
          font-size: 14px;
        }
      }
      .img-list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 20px;
        margin-bottom: 50px;
        .img-item {
          width: 150px;
          height: 150px;
          border: 1px solid #ebebeb;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .shipping-info {
        width: 100%;
        background: #fafafa;
        margin-top: 20px;
        margin-bottom: 40px;
        .info-container {
          padding: 27px 20px;
          display: flex;
          justify-content: space-between;
          .info-box {
            display: flex;
            flex-direction: column;
            .name {
              color: #000000;
              font-size: 14px;
              font-weight: 500;
              span {
                background: rgba(254, 88, 102, 0.12);
                border-radius: 10px;
                color: #fe5866;
                font-size: 12px;
                padding: 5px 12px;
              }
            }
            .other {
              color: #333333;
              font-size: 14px;
            }
          }
          .change-btn {
            color: #808080;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
      .note-info {
        width: 100%;
        background: #fafafa;
        margin-top: 20px;
        margin-bottom: 100px;
        .info-container {
          padding: 27px 20px;
          color: #333333;
          font-size: 14px;
        }
      }
    }
    .select-address {
      width: 100%;
      background: #ffffff;
      padding: 30px 40px 50px 30px;
      margin-bottom: 200px;
      .select-add-title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        width: 100%;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 20px;
      }
      .address-list {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 10px;

        .item-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 27px;
          border-bottom: 1px solid #e5e5e5;
          margin-top: 30px;
          width: 100%;
          .address-item {
            display: flex;
            flex-direction: column;
            line-height: 1.5;
            margin-left: 10px;
            cursor: pointer;
            .name {
              color: #000000;
              font-size: 14px;
              font-weight: bolder;
              span {
                background: rgba(254, 88, 102, 0.12);
                border-radius: 10px;
                color: #fe5866;
                font-size: 12px;
                padding: 5px 12px;
              }
            }
            .address,
            .phone {
              color: #333333;
              font-size: 14px;
            }
          }
          .btn-box {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            .btn-item {
              color: #808080;
              font-size: 12px;
              cursor: pointer;
              &:first-child {
                padding-right: 15px;
              }
              &:last-child {
                padding-left: 15px;
              }
              &:hover {
                color: #fe5866;
                text-decoration: underline;
              }
            }
            .line {
              width: 1px;
              height: 15px;
              background: #808080;
            }
          }
        }
      }
      .add-new-btn {
        color: #3872ab;
        font-size: 14px;
        margin-top: 30px;
        margin-left: 40px;
        cursor: pointer;
      }
      .select-address-btn {
        width: 320px;
        height: 52px;
        background: #fe5866;
        border-radius: 26px;
        color: #ffffff;
        line-height: 52px;
        text-align: center;
        margin-top: 80px;
        cursor: pointer;
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: white;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    z-index: 10;
    .footer-tips{
      width:100%;
      text-align:center;
      font-size:12px;
      margin-top:10px;
      color:red;
      // font-weight:bold;
    }
    .footer-btn-wrap{
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      .price-wrap {
        color: #333333;
        font-size: 16px;
        position: relative;
        margin-right: 20px;

        .shu {
          margin: 0 10px;
        }

        .money1 {
          color: #fa3d5a;
        }

        .money2 {
          color: #fa3d5a;
          font-weight: bold;
          font-size: 20px;
        }

        .btn-detail {
          color: #808080;
          margin: 0 35px;
          font-size: 14px;
          cursor: pointer;
        }

        .detail-modal {
          background: white;
          box-shadow: 0px 0px 20px 0px #a6a6a6;
          z-index: 100;
          position: absolute;
          bottom: 40px;
          right: 0;
          background: white;
          border-radius: 10px;
          padding: 15px;
          width: 240px;

          .p-list {
            .p-item {
              display: flex;
              justify-content: space-around;
              font-size: 14px;
              margin: 10px 0;

              .left {
                font-weight: bold;
                width: 50%;
              }

              .right {
                text-align: right;
                width: 50%;
                color: #fa3d5a;
                font-weight: bold;
              }
            }
          }
        }
      }

      .btn {
        height: 38px;
        line-height: 38px;
        border-radius: 19px;
        font-size: 14px;
        padding: 0 20px;
        cursor: pointer;

        &.btn-confirm {
          width: 200px;
          background: #fa3d5a;
          color: white;
          text-align: center;
        }

        &.btn-back {
          // width: 120px;
          margin-right: 20px;
          background: #ebebeb;
          color: #1c1f23;
          text-align: center;
        }
      }
    }
  }
}

.address-form {
  padding: 30px 20px;
  .form-group {
    margin-bottom: 20px;
    ::v-deep .ivu-form-item-label {
      font-size: 14px;
      color: #212121;
      padding: 0px;
      margin-bottom: 5px;
    }
    ::v-deep .ivu-input {
      border-radius: 2px;
    }
    .input {
      //   width: 100%;
      //   height: 40px;
      //   line-height: 40px;
      //   padding: 0 10px;
      //   outline: none;
      //   background: #ffffff;
      border-radius: 2px;
      //   border: 1px solid #cbcbcb;
    }
  }
  .btn-submit {
    width: 220px;
    height: 40px;
    background: #0d0c22;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
}

.success-popup {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .success-icon {
    width: 66px;
    height: 66px;
    margin-bottom: 30px;
  }
  .success-title {
    color: #333333;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .success-msg {
    text-align: center;
    color: #333333;
    font-size: 14px;
    padding: 0 30px;
    margin-bottom: 58px;
  }
  .success-btn {
    width: 200px;
    height: 46px;
    border-radius: 6px;
    background: #fa3d5a;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
    cursor: pointer;
  }
}

::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
        textarea {
          width: 300px;
          height: 100px;
          border: 1px solid #d9d9d9;
          padding: 5px;
          &::placeholder{
            color:#b3b3b3;
          }

          &::-webkit-input-placeholder{
            color:#b3b3b3;
          }

          &::-moz-placeholder{
            color:#b3b3b3;
          }

          &:-ms-input-placeholder{
            color:#b3b3b3;
          }
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}
::v-deep .ivu-select{
  display:flex;
  align-items:center;
  height:100%;
}

::v-deep .ivu-select-selection{
  width:100%;
  height:100% !important;
  display:flex;
  align-items:center;
  border:none;
}

::v-deep .ivu-select-placeholder{
  color:#b3b3b3 !important;
}

::v-deep .ivu-cascader-rel{
  height:52px;
  line-height:52px;
}

::v-deep .ivu-cascader {
  border:none !important;
  outline:none !important;
  input{
    border:none !important;
    outline:none !important;
  }
}
</style>
